import { Injectable } from '@angular/core';


@Injectable()
export class ComponentUtilities {
   hideLoader() {
    const loader = document.getElementById("reg-loader");
    if (loader) {
      loader.remove();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component.utilities.ts